<template>
  <div class="timer d-flex align-items-center">
    <div class="icon">
      <img src="../assets/timer.svg" alt="" />
    </div>
    <div class="text">
      <p class="mb-0">This will expire in:</p>
      <div class="d-flex">
        <div class="day">
          <p class="mb-0 number">{{ days | two_digits }}</p>
          <p class="mb-0 title">Day</p>
        </div>
        <div class="colon">
          <p class="mb-0">:</p>
        </div>
        <div class="day">
          <p class="mb-0 number">{{ hours | two_digits }}</p>
          <p class="mb-0 title">Hr</p>
        </div>
        <div class="colon">
          <p class="mb-0">:</p>
        </div>
        <div class="day">
          <p class="mb-0 number">{{ minutes | two_digits }}</p>
          <p class="mb-0 title">Min</p>
        </div>
        <div class="colon">
          <p class="mb-0">:</p>
        </div>
        <div class="day">
          <p class="mb-0 number">{{ seconds | two_digits }}</p>
          <p class="mb-0 title">Sec</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import moment from "moment";

export default {
  name: "CountDown",
  mounted() {
    this.updateCountDown();
    window.setInterval(() => {
      this.updateCountDown();
    }, 1000);
  },
  props: {
    date: {
      type: String,
    },
  },
  data() {
    return {
      now: Math.floor(new Date().getTime() / 1000),
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  },
  methods: {
    updateCountDown() {
      let now = new Date().getTime();
      var countDownDate = new Date(this.date).getTime();
      let timeleft = countDownDate - now;
      this.days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
    },
  },
  computed: {
    // dateInMilliseconds() {
    //   return Math.floor(Date.parse(this.date.replace(/-/g, " ")) / 1000);
    // },
    // seconds() {
    //   return (this.dateInMilliseconds - this.now) % 60;
    // },
    // minutes() {
    //   return Math.floor((this.dateInMilliseconds - this.now) / 60) % 60;
    // },
    // hours() {
    //   return Math.floor((this.dateInMilliseconds - this.now) / 60 / 60) % 24;
    // },
    // days() {
    //   // console.log(this.dateInMilliseconds , (this.dateInMilliseconds - this.now))
    //   return Math.floor((this.dateInMilliseconds - this.now) / 60 / 60 / 24);
    // },
  },
  filters: {
    two_digits: function(value) {
      if (value < 0) {
        return "00";
      }
      if (Number.isNaN(value)) {
        return "00";
      }
      if (value.toString().length <= 1) {
        return `0${value}`;
      }
      return value;
    },
  },
};
</script>
<style scoped lang="scss">
.timer {
  padding: 12px 14px 16px 12px;
  background: #ffffff;
  border-radius: 5px;

  .icon {
    margin-right: 44.5px;
  }

  .text {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #313c4e;
    }

    .colon {
      padding: 4px 8px;

      p {
        font-size: 24px;
        line-height: 24px;
      }
    }

    .day {
      .number {
        font-size: 24px;
        line-height: 36px;
        width: 32px;
      }

      .title {
        font-size: 11px;
        line-height: 16px;
        letter-spacing: -0.02em;
      }
    }
  }
}
</style>
